import { ViewPlugin } from '@codemirror/view';
import { syntaxHighlighting } from '@codemirror/language';
import { markdown } from '@codemirror/lang-markdown';

import tagParser from './tagParser';
import highlightStyle from './highlightStyle';
import RichEditPlugin from './richEdit';
import renderBlock from './renderBlock';

import type { Config } from '@markdoc/markdoc';

export type MarkdocPluginConfig = { lezer?: any, markdoc: Config };

function createMarkdocPlugin(config: MarkdocPluginConfig) {
  const mergedConfig = {
    ...config.lezer ?? [],
    // extensions: [...config.lezer?.extensions ?? []]
    extensions: [tagParser, ...config.lezer?.extensions ?? []]
  };

  return ViewPlugin.fromClass(RichEditPlugin, {
    decorations: v => v.decorations,
    provide: v => [
      renderBlock(config.markdoc),
      syntaxHighlighting(highlightStyle),
      markdown(mergedConfig)
    ],
    eventHandlers: {
      mousedown({ target }, view) {
        if (target instanceof Element && target.matches('.cm-markdoc-renderBlock *')){
        //   console.log('hit...');
          view.dispatch({ selection: { anchor: view.posAtDOM(target) } });
        }
      }
    }
  });
}

export default createMarkdocPlugin;
